import { apiClient } from '@app/lib'
import { type ApiResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const usePhone = (initialData?: string | null | undefined) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    queryKey: ['phone'],
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<{ phoneNumber: string | null | undefined }>>(`/api/phone`)

      return data.data?.phoneNumber
    },
    initialData
  })
}
